import svg4everybody from 'svg4everybody';

import { customEventPolyfill } from './modules/Utils';
import Select from './modules/Select';
import Toggle from './modules/Toggle';
import Tab from './modules/Tab';
import Dropdown from './modules/Dropdown';
import Modal from './modules/Modal';
import Googlemap from './modules/Googlemap';
import SwiperSlider from './modules/Swiper';

window.addEventListener('DOMContentLoaded', () => {
  svg4everybody();
  customEventPolyfill();

  window.myApp = {};

  window.myApp.Toggle = Toggle;
  window.myApp.toggles = new Toggle();

  window.myApp.Dropdown = Dropdown;
  window.myApp.dropdowns = new Dropdown();

  window.myApp.Tab = Tab;
  window.myApp.tabs = new Tab();

  window.myApp.Select = Select;
  window.myApp.selects = new Select();

  window.myApp.Modal = Modal;
  window.myApp.modals = new Modal();

  window.myApp.Googlemap = Googlemap;
  window.myApp.googlemaps = new Googlemap();

  window.myApp.Swiper = SwiperSlider;
  window.myApp.swipers = new SwiperSlider();
});



// WEBPACK FOOTER //
// ./app/scripts/main.js